import { useMemo } from "react";
import type { FlowResponse } from "@/api";
import {
  addFlowTeamMember,
  addFlowUserMember,
  getFlowMembersOptions,
  getFlowMembersQueryKey,
  removeFlowTeamMember,
  removeFlowUserMember,
  updateFlowTeamMember,
  updateFlowUserMember,
} from "@/api";
import { type MembershipApi, MembershipPanel } from "@/components/build/MembershipPanel";
import { useCurrentUser } from "@/features/account/useCurrentUser";

/** Flows' Access tab: the membership model, via the shared MembershipPanel. */
export function FlowAccessTab({ flow }: Readonly<{ flow: FlowResponse }>) {
  const me = useCurrentUser();

  const api = useMemo<MembershipApi>(
    () => ({
      membersOptions: () => getFlowMembersOptions({ path: { flow_uuid: flow.uuid } }),
      membersQueryKey: () => getFlowMembersQueryKey({ path: { flow_uuid: flow.uuid } }),
      addUser: (id, role) =>
        addFlowUserMember({ path: { flow_uuid: flow.uuid }, body: { userUuid: id, role }, throwOnError: true }),
      updateUserRole: (id, role) =>
        updateFlowUserMember({ path: { flow_uuid: flow.uuid, user_uuid: id }, body: { role }, throwOnError: true }),
      removeUser: (id) => removeFlowUserMember({ path: { flow_uuid: flow.uuid, user_uuid: id }, throwOnError: true }),
      updateTeamRole: (id, role) =>
        updateFlowTeamMember({ path: { flow_uuid: flow.uuid, team_uuid: id }, body: { role }, throwOnError: true }),
      removeTeam: (id) => removeFlowTeamMember({ path: { flow_uuid: flow.uuid, team_uuid: id }, throwOnError: true }),
      addTeam: (id, role) =>
        addFlowTeamMember({ path: { flow_uuid: flow.uuid }, body: { teamUuid: id, role }, throwOnError: true }),
    }),
    [flow.uuid],
  );

  return <MembershipPanel api={api} currentUserUuid={me.data?.user.uuid} />;
}
